import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createBasket, updateBasket } from '@store/basket/actions';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { guestSelectors } from '@store/guest/selectors';
import { signIn } from '@store/guest/actions';
import { yourJourneySelectors } from '@store/yourJourney';
import { FacilityDetailV2 } from './FacilityDetailV2';

const mapStateToProps = (state: any) => ({
  property: entitySelectors.getProperty(state),
  basketDetails: basketSelectors.getBasketDetails(state),
  basketGuests: basketSelectors.getBasketGuests(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  userHasAccessToFacilities: guestSelectors.userHasAccessToSpaEntity(state, 'facilities'),
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      createBasket,
      updateBasket,
      signIn,
    },
    dispatch
  );

export const FacilityDetailV2Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(FacilityDetailV2);
